import { TFunction } from 'i18next'
import i18n from '../../../client/src/i18n'
import type { EndUserCampaign } from '../lib/api/types'
import {
  ECFlowScreensType,
  type EcFlowButtonKey,
} from '../../../server/src/schema/ec-flow-texts.schema'

export const buttonFallbackKeys: Record<EcFlowButtonKey, string> = {
  view: 'ec.yes_button',
  next: 'ec.next',
  back: 'ec.back',
  finish: 'ec.finish',
  copy: 'ec.invite.copy',
  share: 'ec.invite.share',
  copied: 'ec.invite.copied',
}

// The buttons each end-user page shows (keep in step with the pages); Finalise shows a field per entry.
// A text still applies to every screen with that button.
export const screenButtonKeys: Partial<Record<string, EcFlowButtonKey[]>> = {
  [ECFlowScreensType.HOME]: ['view'],
  [ECFlowScreensType.INCENTIVE]: ['next', 'back'],
  [ECFlowScreensType.QUESTIONNAIRE]: ['next', 'back'],
  [ECFlowScreensType.INVITE]: [
    'copy',
    'share',
    'copied',
    'next',
    'finish',
    'back',
  ],
  [ECFlowScreensType.HAPPINESS_CHECK]: ['finish', 'back'],
}

// The admin's text for this button, or the standard text when it is empty.
export function buttonText(
  campaign: EndUserCampaign,
  key: EcFlowButtonKey,
  t: TFunction<'translation', undefined>,
): string {
  const custom = campaign?.ecFlowTexts?.ecFlowTexts?.buttons?.[key]
  return typeof custom === 'string' && custom.trim()
    ? custom.trim()
    : t(buttonFallbackKeys[key])
}

// getFixedT, not changeLanguage: the typed screen texts are stored under `nl` only,
// so switching the global language would hide them.
export function errorT(campaign: EndUserCampaign) {
  const lang =
    campaign?.ecFlowTexts?.ecFlowTexts?.errorLanguage === 'en' ? 'en' : 'nl'
  return i18n.getFixedT(lang)
}
